module.exports = __webpack_public_path__ + "img/mini-drip-kettle.e006cfb6.svg";